var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSqlDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "-3 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 6.857v4.286C42 14.92 32.594 18 21 18S0 14.92 0 11.143V6.857C0 3.08 9.406 0 21 0s21 3.08 21 6.857zM42 16.5v9.643C42 29.92 32.594 33 21 33S0 29.92 0 26.143V16.5c4.512 3.107 12.77 4.554 21 4.554S37.488 19.607 42 16.5zm0 15v9.643C42 44.92 32.594 48 21 48S0 44.92 0 41.143V31.5c4.512 3.107 12.77 4.554 21 4.554S37.488 34.607 42 31.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlDatabase);
export default __webpack_public_path__ + "static/media/sql-database.dbeafcd2cd44a98151f8d60a0ace382b.svg";
export { ForwardRef as ReactComponent };